import React, { useState } from "react";
import styled from "styled-components";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding-bottom: 1rem;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  padding-bottom: 0.5rem;
  color: var(--tertiary-font-color);
  font-family: Georgia, serif;
  cursor: pointer;
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-family: Verdana, sans-serif;
  color: var(--secondary-font-color);
  cursor: pointer;

  input {
    width: 1rem;
    height: 1rem;
    border: 1px solid var(--tertiary-font-color);

    appearance: none; /* Remove default browser styles */
    -webkit-appearance: none; /* For Safari */
    -moz-appearance: none; /* For Firefox */
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input:checked {
    background-color: var(--fill-green);
  }

  input:checked::before {
    content: "✓"; /* Keeps the default checkmark */
    color: white; /* Change if needed */
    font-size: 0.8rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export interface Props {
  label: string;
  isExpanded: boolean;
  selectedValues: string[];
  onChange: (selectedValues: string[]) => void;
  name: string;
  options: {
    value: string;
    label: string;
  }[];
}

const Checkboxes: React.FC<Props> = ({
  label,
  selectedValues,
  onChange,
  name,
  options,
  isExpanded,
}) => {
  const [isOpen, setIsOpen] = useState(isExpanded);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    const newSelectedValues = checked
      ? [...selectedValues, value]
      : selectedValues.filter((selected) => selected !== value);

    onChange(newSelectedValues);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <Wrapper>
      <Label onClick={toggleDropdown}>
        {label} {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </Label>
      {isOpen && (
        <CheckboxContainer>
          {options.map((option) => (
            <CheckboxLabel key={option.value}>
              <input
                type="checkbox"
                name={name}
                value={option.value}
                checked={
                  selectedValues && selectedValues.includes(option.value)
                }
                onChange={handleCheckboxChange}
              />
              {option.label}
            </CheckboxLabel>
          ))}
        </CheckboxContainer>
      )}
    </Wrapper>
  );
};

export default Checkboxes;
